module.exports = __webpack_public_path__ + "3e5d93897f1c2cb0bd1ee53f4c881096.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/security.svg
// module id = 780
// module chunks = 0